import { render } from "./DhHeader.vue?vue&type=template&id=7089e1f0"
import script from "./DhHeader.vue?vue&type=script&lang=ts"
export * from "./DhHeader.vue?vue&type=script&lang=ts"
script.render = render

export default script